import React, { useState, useRef, useEffect } from 'react';
import { usePanelModify } from '../../modules/panel';
import { useDispatch } from 'react-redux';
import { useDragHandler } from '../../utils/useDragHandler';
import './PanelTypeMenus.css' 
import { setLastBasePoint } from '../../redux/utilsSlice';
import { COMMANDS } from '../../utils/commonProperties';
import { getObjectById } from '../../utils/getObjectById';

export default function CabinTypeMenu({
  x,
  y,
  value,
  onClose,
  onAddPositionChange, 
  onActionSelect,
  cabinDetails,
  onDrag,
  scene,
}) {
   const basePoint= cabinDetails.basePoint || { x: 0, y: 0, z: 0 };

  const dispatch = useDispatch();

  const [addPosition, setAddPosition] = useState('start'); 
  const [panelName,setPanelName]=useState("ADP")
  const [panel ,setPanel ]=useState(null)
  const [details,setDetails]=useState({
    kullanimAmac:"Mesken",
    aboneTipi:"Mesken",
    kuruluGuc:0,
    talepFak:"60-40%",
    talepGuc:0,
    faz:"rst",
    akim:0,
  })
  const menuRef = useRef(null);
   
  const panelId = cabinDetails.id || cabinDetails.ID;
  const housingId =  cabinDetails.housingId; 

  useEffect(() => {
   dispatch(setLastBasePoint(basePoint));
 }, [dispatch, basePoint]);

  useEffect(()=>{
    if(!panel)return
  
    const updatedPanel= updatePanel(panel)
    setDetails(updatedPanel.details)
  },[panel]) 

  const { setCount ,updatePanel} = usePanelModify(scene);

  const handlePositionChange = (e) => {
    const val = e.target.value;
    setAddPosition(val);
    onAddPositionChange(val);
  };

  const handleAction = (actionType) => () => {
    const panel = getObjectById(scene, panelId);
    if (!panel) return;

    const currentOutCount = panel.userData.outs?.length || 0;
    const newCount = currentOutCount + 1;
 
    setCount(panelId, newCount,housingId,{addPosition:addPosition,command:actionType});
    
    setTimeout(() => {
      const updatedPanel = getObjectById(scene, panelId);
      const latestOut = updatedPanel?.userData.outs?.at(-1);
  
    }, 50);
   
    onClose();
  };

  const { handleMouseDown, handleMouseMove, handleMouseUp } = useDragHandler(onDrag);
  
  const handleMouseDownWithStop = (e) => {
    e.stopPropagation();
    handleMouseDown(e);
  };
  const handleKullanimAmac = (val) => {
    const kullanimAmac=val.target.value
    let talepFak="100%"
switch(kullanimAmac){
    case "Mesken"   :  talepFak="60-40%";   break  ;
    case "İşYeri"   :  talepFak="100-50%";   break  ;
    case "Müşterek" :  talepFak="100%";   break ;
    case "Asansör"  :  talepFak="55%";   break ;        
}
 //    setKullanimAmac(val)
    
      setPanel(prev => ({
        ...prev,
        details: {
          ...prev.details,
          kullanimAmac:kullanimAmac,
          talepFak: talepFak
        },
      }))

  };
  useEffect(() => {
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div
      ref={menuRef} className="panel-type-menu" style={{ left: x, top: y }}
    >
      <div
        onMouseDown={handleMouseDownWithStop}
        className="panel-type-menu-header"
      > 
        {panelName } /{details.kuruluGuc} KOFRE
        <button
          className="close-button"
          onClick={e => { e.stopPropagation(); onClose(); }}
        >
          ×
        </button>
      </div>

      <div  className="panel-type-options">
     

        <div  className="panel-type-buttons">
          <button onClick={handleAction(COMMANDS.DRAW_MAIN_PANEL)} className="my-button">ADP Ekle</button>
        </div>

   
   
      </div>
    </div>
  );
}

 